<script setup>
import { useI18n } from 'vue-i18n';
import Switch from 'dashboard/components-next/switch/Switch.vue';

const { t } = useI18n();

const consentEnabled = defineModel('consentEnabled', {
  type: Boolean,
  default: true,
});
const consentText = defineModel('consentText', { type: String, default: '' });
</script>

<template>
  <div class="flex flex-col gap-4">
    <div class="flex flex-col gap-1">
      <h3 class="text-base font-semibold text-n-slate-12">
        {{ t('FORMS_MGMT.EDITOR.CONSENT.TITLE') }}
      </h3>
      <p class="text-sm text-n-slate-11">
        {{ t('FORMS_MGMT.EDITOR.CONSENT.DESCRIPTION') }}
      </p>
    </div>

    <label class="flex items-center gap-2">
      <Switch v-model="consentEnabled" />
      <span class="text-sm font-medium text-n-slate-12">
        {{ t('FORMS_MGMT.EDITOR.CONSENT.ENABLED') }}
      </span>
    </label>

    <label v-if="consentEnabled" class="flex flex-col gap-1">
      <span class="text-sm font-medium text-n-slate-12">
        {{ t('FORMS_MGMT.EDITOR.CONSENT.TEXT_LABEL') }}
      </span>
      <textarea
        v-model="consentText"
        rows="2"
        class="form-textarea"
        :placeholder="t('FORMS_MGMT.EDITOR.CONSENT.TEXT_PLACEHOLDER')"
      />
    </label>
  </div>
</template>
